import { PathGroup } from '../api/path-group';

export const Paths: PathGroup = {
    base: '/',
    contact: 'kontakt',
    fees: 'oplaty',
    rodo: 'rodo',
    notarialActivities: {
        base: 'czynnosci-notarialne',
        inheritanceLaw: 'prawo-spadkowe',
        familyLaw: 'prawo-rodzinne',
        realEstate: 'nieruchomosci',
        certificates: 'sprawy-gospodarcze-i-inne-czynnosci',
    }
}
